import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../dynamic/component-base';

@Component({
  selector: 'app-metabase-frame',
  templateUrl: './metabase-frame.component.html',
  styleUrls: ['./metabase-frame.component.scss']
})
export class MetabaseFrameComponent extends ComponentBase implements OnInit { 

  iframeUrl: string = '';

  constructor() {
    super()
  }

  ngOnInit(): void {
    this.iframeUrl = this.gerarIframeUrl();
  }

  gerarIframeUrl(): string {
    return `${this.attribute.value}#theme=transparent&bordered=true&titled=true`;
  }
}